package org.lennycodes.hldi.pages.admin


import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import org.lennycodes.hldi.components.Routes


@Page(Routes.resources)
@Composable
fun AdminResources(){

    AdminLayout {

        Resources()

    }

}